(function () {
  function cartRoute(path) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + path;
  }

  function bindQuickAddForms(root) {
    if (!root) return;
    root.querySelectorAll('.tcb-fbt-add-form').forEach(function (form) {
      if (form.getAttribute('data-tcb-cart-bound') === '1') return;
      form.setAttribute('data-tcb-cart-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.tcb-fbt-add, .tcb-cart-fbt__add');
        var resetLabel = btn ? btn.textContent : 'Add';
        var title = btn ? btn.getAttribute('data-tcb-product-title') : '';
        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Adding…';
        }
        fetch(cartRoute('/cart/add.js'), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            return r.json().then(function (data) { return { ok: r.ok, data: data }; });
          })
          .then(function (res) {
            if (!res.ok) {
              if (btn) {
                btn.textContent = 'Unavailable';
                setTimeout(function () {
                  btn.disabled = false;
                  btn.textContent = resetLabel;
                }, 1800);
              }
              return;
            }
            if (btn) {
              btn.textContent = 'Added ✓';
              setTimeout(function () {
                btn.disabled = false;
                btn.textContent = resetLabel;
              }, 1600);
            }
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true,
              detail: { scrollToTop: false }
            }));
            document.dispatchEvent(new CustomEvent('tcb:cart-updated'));
            fetch(cartRoute('/cart.js'), { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (!cart || typeof cart.item_count !== 'number') return;
                document.querySelectorAll('.header__cart-count, [data-tcb-cart-count]').forEach(function (el) {
                  el.textContent = cart.item_count;
                  if (el.hasAttribute('data-tcb-cart-count')) el.hidden = cart.item_count === 0;
                });
              })
              .catch(function () {});
          })
          .catch(function () {
            form.submit();
          });
      });
    });
  }

  function initCartFbtCarousel(wrap) {
    if (!wrap || wrap.getAttribute('data-bound') === '1') return;
    wrap.setAttribute('data-bound', '1');

    var track = wrap.querySelector('[data-tcb-cart-fbt-track]');
    var prevButtons = wrap.querySelectorAll('[data-tcb-cart-fbt-prev]');
    var nextButtons = wrap.querySelectorAll('[data-tcb-cart-fbt-next]');
    if (!track || (!prevButtons.length && !nextButtons.length)) return;

    var prev = prevButtons[0];
    var next = nextButtons[0];

    function step(dir) {
      var card = track.querySelector('.tcb-cart-fbt__card');
      var amount = card ? card.offsetWidth + 10 : 240;
      track.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prevButtons.forEach(function (btn) { btn.disabled = track.scrollLeft <= 2; });
      nextButtons.forEach(function (btn) { btn.disabled = track.scrollLeft >= max; });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    prevButtons.forEach(function (btn) {
      if (btn !== prev) btn.addEventListener('click', function () { step(-1); });
    });
    nextButtons.forEach(function (btn) {
      if (btn !== next) btn.addEventListener('click', function () { step(1); });
    });
    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  function initCartUpsells(root) {
    if (!root) return;
    bindQuickAddForms(root);
    root.querySelectorAll('[data-tcb-cart-fbt]').forEach(function (wrap) {
      initCartFbtCarousel(wrap);
    });
  }

  window.TcbCartDrawerInitUpsells = initCartUpsells;

  function setCartOpen(open) {
    var cart = document.getElementById('mini-cart');
    var toggle = document.querySelector('[data-action="toggle-mini-cart"]');
    if (!cart) return;
    cart.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var cartIcon = toggle.querySelector('.header__cart-icon');
      if (cartIcon) cartIcon.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    document.documentElement.classList.toggle('is-locked', open);
    syncDrawerOpenState(cart);
  }

  function bindCartToggle() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-action="toggle-mini-cart"]');
      if (!toggle) return;
      if (window.theme && window.theme.cartType === 'page') return;
      var cart = document.getElementById('mini-cart');
      if (!cart) return;
      e.preventDefault();
      e.stopPropagation();
      setCartOpen(cart.getAttribute('aria-hidden') === 'true');
    }, true);
  }

  function syncDrawerOpenState(cart) {
    var open = cart.getAttribute('aria-hidden') === 'false';
    document.documentElement.classList.toggle('tcb-cart-drawer-open', open);
    document.querySelectorAll('[data-tcb-hero-quote-card]').forEach(function (el) {
      el.classList.toggle('is-hidden', open);
    });
    if (open) resetDrawerSizing(cart);
  }

  function resetDrawerSizing(cart) {
    if (!cart) return;
    cart.style.maxHeight = '';
    cart.style.height = '';
    var content = cart.querySelector('.mini-cart__content');
    if (content) content.style.maxHeight = '';
  }

  function initCartDrawer() {
    var cart = document.getElementById('mini-cart');
    if (!cart || cart.getAttribute('data-tcb-drawer-init') === '1') return;
    cart.setAttribute('data-tcb-drawer-init', '1');
    cart.classList.add('tcb-cart-drawer');

    if (!cart.getAttribute('data-tcb-cart-portal')) {
      cart.setAttribute('data-tcb-cart-portal', '1');
      document.body.appendChild(cart);
    }

    syncDrawerOpenState(cart);
    var observer = new MutationObserver(function () {
      syncDrawerOpenState(cart);
    });
    observer.observe(cart, { attributes: true, attributeFilter: ['aria-hidden'] });

    bindCartToggle();

    document.documentElement.addEventListener('product:added', function () {
      if (window.theme && window.theme.pageType !== 'cart' && window.theme.cartType === 'drawer') {
        setCartOpen(true);
      }
    });

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-action="close-mini-cart"]');
      if (!closeBtn) return;
      e.preventDefault();
      setCartOpen(false);
    });

    document.addEventListener('click', function (e) {
      if (!document.documentElement.classList.contains('tcb-cart-drawer-open')) return;
      if (e.target.closest('#mini-cart, [data-action="toggle-mini-cart"]')) return;
      setCartOpen(false);
    });

    bindQuickAddForms(cart);
    initCartUpsells(cart);

    var cartPage = document.querySelector('[data-section-type="cart"]');
    if (cartPage) initCartUpsells(cartPage);

    document.addEventListener('cart:rerendered', function () {
      var fresh = document.getElementById('mini-cart');
      if (!fresh) return;
      fresh.classList.add('tcb-cart-drawer');
      if (!fresh.getAttribute('data-tcb-cart-portal')) {
        fresh.setAttribute('data-tcb-cart-portal', '1');
        document.body.appendChild(fresh);
      }
      bindQuickAddForms(fresh);
      fresh.querySelectorAll('[data-tcb-cart-fbt]').forEach(function (el) {
        el.removeAttribute('data-bound');
      });
      initCartUpsells(fresh);
      syncDrawerOpenState(fresh);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }
})();
